import dynamic from 'next/dynamic';
export default dynamic(() => import(/* webpackChunkName: "blazePbModalAdaptor" */'./ModalAdapter'));
//# sourceMappingURL=index.js.map